export default {
  title: "",
  subtitle: "",
  path: "person_list",
  paragraph: "You can also list the customers already registered, using the following endpoint. Note that the API has a limit from 100 to 100 for each request.",
  request:  {
    method: "GET", 
    endpoint: "/subject/people",
    responses: {
      "data": [
        {
          "updated_at": "2021-03-25T18:32:54.448951",
          "status": "approved",
          "social_name": "Mauricio Silva",
          "required_clearance_level": 1,
          "references": [],
          "phone_number": "99123-2313",
          "net_monthly_average_income": "1000.00",
          "inserted_at": "2021-03-13T02:05:34.206799",
          "id": "0be2c99a-bb6e-4a1f-97a5-5eeaff0671c8",
          "fiscal_country": "Brasil",
          "email": "mauricio-silva@email.com",
          "documents": [
            {
              "labels": [
                "rg-number",
                "cpf-number",
                "rg-photo"
              ],
              "id": "58ca9984-3cb8-4462-97a6-0b2f7776ed24",
              "file_url": "http://somedomain.com/files/driverslicense.jpg",
              "file_type": "image/jpeg"
            },
            {
              "labels": [
                "address-proof"
              ],
              "id": "5d2cce7a-3814-4baf-a1b5-077db9d3bdf7",
              "file_url": "http://somedomain.com/files/doc.pdf",
              "file_type": "application/pdf"
            }
          ],
          "document_type": "cpf",
          "document_number": "24189952087",
          "clearance_level": 1,
          "birth_date": "1990-12-03",
          "address_street": "Rua Presidente Wenceslau",
          "address_state": "SP",
          "address_postal_code": "13090509",
          "address_number": "708",
          "address_country": "BR",
          "address_complement": "Jardim Pres. Wenceslau",
          "address_city": "Campinas"
        }
      ]
    }
  },
   queryPayload: [
    {
      name: "last_id",
      type: "string",
      required: false,
      description: "Last customer UUID for pagination",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonsList.js